/**
 * Tenant theme overrides (brand/white-label.md). The rules (which tokens, stored over bundled, the CSS) live in
 * `@teslyn/domain` so Teslyn Field applies the same ones (issue #43); this module adds the DOM step.
 */
import { themeCss, type ThemeOverrides } from '@teslyn/domain';

export {
  hasOverrides,
  OVERRIDABLE_TOKENS as OVERRIDABLE,
  sanitiseOverrides,
  themeCss,
  type OverridableToken,
  type ThemeOverrides,
  type ThemeValue,
} from '@teslyn/domain';

export const THEME_STYLE_ID = 'teslyn-tenant-theme';

/** Inject (or replace) the one tenant `<style>` block, after the tokens stylesheet. */
export function applyTheme(o: ThemeOverrides, doc: Document = document): void {
  let el = doc.getElementById(THEME_STYLE_ID) as HTMLStyleElement | null;
  if (!el) {
    el = doc.createElement('style');
    el.id = THEME_STYLE_ID;
    doc.head.appendChild(el);
  }
  el.textContent = themeCss(o);
}
